import { Tournament } from '../models';
import { TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetPublicTournamentsUseCase {
  constructor(private tournamentRepository: TournamentRepository) {}

  async execute(limit?: number, offset?: number): Promise<Tournament[]> {
    logger.debug('GetPublicTournaments', 'Fetching public tournaments', { limit, offset });

    const tournaments = await this.tournamentRepository.getPublic(limit, offset);

    logger.debug('GetPublicTournaments', 'Public tournaments fetched', { count: tournaments.length });

    return tournaments;
  }
}
